import { Slot } from "@radix-ui/react-slot";
import type * as React from "react";

import { Label } from "../../components";
import { cn } from "../../utils";
import { useFormField } from "./form-field";

function FieldLabel({ className, ...props }: React.ComponentProps<typeof Label>) {
  const { error, formItemId } = useFormField();

  return <Label className={cn(error && "text-destructive", className)} htmlFor={formItemId} {...props} />;
}

function FieldControl({ ...props }: React.ComponentProps<typeof Slot>) {
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();

  return (
    <Slot
      id={formItemId}
      aria-describedby={error ? `${formDescriptionId} ${formMessageId}` : `${formDescriptionId}`}
      aria-invalid={!!error}
      {...props}
    />
  );
}

function FieldDescription({ className, ...props }: React.ComponentPropsWithRef<"p">) {
  const { formDescriptionId } = useFormField();

  return <p id={formDescriptionId} className={cn("text-sm text-muted-foreground text-wrap", className)} {...props} />;
}

function FieldMessage({ children, className, ...props }: React.ComponentPropsWithRef<"p">) {
  const { error, formMessageId } = useFormField();
  const body = error ? String(error?.message) : children;

  if (!body) {
    return null;
  }

  return (
    <p id={formMessageId} className={cn("text-sm font-medium text-destructive", className)} {...props}>
      {body}
    </p>
  );
}

export { FieldControl, FieldDescription, FieldLabel, FieldMessage };
